import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clock",
  "use": "icon-clock-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-clock\">\n    <g data-name=\"Icons/16px/black/clock\">\n        <circle cx=\"7\" cy=\"7\" r=\"7\" transform=\"translate(.5 .5)\" style=\"fill:none;stroke:CurrentColor;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10\" />\n        <path d=\"M0 0v4h4\" transform=\"translate(7.5 3.5)\" style=\"fill:none;stroke:CurrentColor;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol